






























import { Component, Prop, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  UserNewArrivalNoticeGenreTable,
  UserNewArrivalNoticeTableItem
} from '@/components/organisms/UserNewArrivalNoticeGenreTable'
import {
  UserNewArrivalNoticeKeywordTable,
  UserNewArrivalNoticeKeywordTableItem
} from '@/components/organisms/UserNewArrivalNoticeKeywordTable'
import { UserDetailStateInfo } from '@/types'
import {
  UserNewArrivalNoticeMagazineTable,
  UserNewArrivalNoticeMagazineTableItem
} from '@/components/organisms/UserNewArrivalNoticeMagazineTable'

export interface UserContentNewArrivalNoticeItem {
  genres: UserNewArrivalNoticeTableItem[]
  keywords: UserNewArrivalNoticeKeywordTableItem[]
  magazines: UserNewArrivalNoticeMagazineTableItem[]
}

export const defaultUserContentNewArrivalNoticeItem = (): UserContentNewArrivalNoticeItem => ({
  genres: [],
  keywords: [],
  magazines: []
})

@Component({
  components: {
    UserNewArrivalNoticeMagazineTable,
    UserNewArrivalNoticeGenreTable,
    UserNewArrivalNoticeKeywordTable
  }
})
export default class UserContentNewArrivalNotice extends ComponentVue {
  @PropSync('item', {
    type: Object,
    required: true
  })
  inputItem!: UserContentNewArrivalNoticeItem

  @Prop({
    type: Object,
    required: true
  })
  state!: UserDetailStateInfo

  @Prop({
    type: Number,
    required: true
  })
  height!: number
}
